import { Alert } from "reactstrap";
import { useTranslation } from "next-i18next";
import { getCurrentUser, User } from "../../../services/auth"

type VerifyProps = { user: User }

const Verify: React.FC<VerifyProps> = ({ user }) => {
  const { t } = useTranslation("auth");

  return (
    <>
      <h1 className="mb-4">{t("signup.title")}</h1>
      <Alert color="info" className="mt-6">
        {t("verify.description")}
        <br />
        <br />
        {user.username} {/* References the E-mail */}
      </Alert>
    </>
  );
};

export default Verify;
